import React, { useState } from "react";
import "./Change_Login_Password.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { AuthChangePassword } from "../../features/auth/Slice";
import Successfull_strip_modal from "../Common/Common_Component/Common_Modal/Successfull_strip_modal/Successfull_strip_modal";

function Change_Login_Password() {
  const dispatch = useDispatch();

  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [modalMessage, setModalMessage] = useState("Suceesfull");
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      old_password: "",
      new_password: "",
      confirm_password: "",
    },
  });

  const onSubmit = async (data) => {
    try {
      const formData = new FormData();
      formData.append("old_password", data?.old_password);
      formData.append("password", data?.new_password);
      formData.append("confirm_password", data?.confirm_password);

      const res = await dispatch(AuthChangePassword(formData));

      if (res.meta?.requestStatus === "fulfilled") {
        reset();
        setModalShow(true);
        setModalMessage(res?.payload?.data);
        setTimeout(() => {
          setModalShow(false);
          navigate(-1);
        }, 3000);

      } else {
        setModalShow(true);
        setModalMessage(res?.payload?.errors || "Deposit failed.");
        setTimeout(() => {
          setModalShow(false);
        }, 3000);
        console.error("Change password rejected:", res?.payload?.errors);
      }
    } catch (error) {
      console.error("Change password error:", error);
    }
  };

  return (
    <>
      <section className="Change_Login_Password login-page">
        <Common_white_header headingText={"Change Login Password"} />

        <div className="container">
          <Form onSubmit={handleSubmit(onSubmit)} noValidate>

            {/* Current Password */}
            <div className="form-group field_holder">
              <Form.Label>
                <img src="/assets/images/icons/lock.png" alt="icon" className="login_lable_icons" />{" "}
                Login Password
              </Form.Label>
              <div className="password_input">
                <Form.Control
                  type={showOldPassword ? "text" : "password"}
                  placeholder="Enter Login Password"
                  {...register("old_password", {
                    required: "Current password is required",
                  })}
                />
                <span className="eye-icon" onClick={() => setShowOldPassword(!showOldPassword)}>
                  {showOldPassword ? <FaEye /> : <FaEyeSlash />}
                </span>
              </div>
              {errors.old_password && (
                <small className="text-danger">{errors.old_password.message}</small>
              )}
            </div>

            {/* New Password */}
            <div className="form-group field_holder">
              <Form.Label>
                <img src="/assets/images/icons/lock.png" alt="icon" className="login_lable_icons" />{" "}
                New Login Password
              </Form.Label>
              <div className="password_input">
                <Form.Control
                  type={showNewPassword ? "text" : "password"}
                  placeholder="Enter New Login Password"
                  {...register("new_password", {
                    required: "New password is required",
                    minLength: {
                      value: 6,
                      message: "Password must be at least 6 characters",
                    },
                    maxLength: {
                      value: 20,
                      message: "Password cannot exceed 20 characters",
                    },
                    pattern: {
                      value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/,
                      message: "Must include uppercase, lowercase, number and special character",
                    },
                    validate: {
                      notSameAsOld: (value) =>
                        value !== watch("old_password") ||
                        "New password cannot be same as current password",
                    },
                  })}
                />
                <span className="eye-icon" onClick={() => setShowNewPassword(!showNewPassword)}>
                  {showNewPassword ? <FaEye /> : <FaEyeSlash />}
                </span>
              </div>
              {errors.new_password && (
                <small className="text-danger">{errors.new_password.message}</small>
              )}
            </div>

            {/* Confirm New Password */}
            <div className="form-group field_holder">
              <Form.Label>
                <img src="/assets/images/icons/lock.png" alt="icon" className="login_lable_icons" />{" "}
                Confirm New Password
              </Form.Label>
              <div className="password_input">
                <Form.Control
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder="Enter Confirm New Password"
                  {...register("confirm_password", {
                    required: "Please confirm your new password",
                    validate: (value) =>
                      value === watch("new_password") || "Passwords do not match",
                  })}
                />
                <span className="eye-icon" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                  {showConfirmPassword ? <FaEye /> : <FaEyeSlash />}
                </span>
              </div>
              {errors.confirm_password && (
                <small className="text-danger">{errors.confirm_password.message}</small>
              )}
            </div>

            <Link to={"/forgot-password"}>
              <div className="span_text_holder">
                <p>
                  Forgot Original Login Password{" "}
                  <FontAwesomeIcon icon={faChevronRight} className="ms-2" />
                </p>
              </div>
            </Link>

            <button
              type="submit"
              className="btn_register_bg"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Saving..." : "Save changes"}
            </button>

          </Form>
        </div>
      </section>
      <Successfull_strip_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        textMsg={modalMessage}
      />
    </>
  );
}

export default Change_Login_Password;